import { reactive } from 'vue';

interface WindowDimensions {
  width: number;
  height: number;
}

let windowDimensions: WindowDimensions;

export const useWindowDimensions: () => WindowDimensions = () => {
  if (!windowDimensions) {
    windowDimensions = reactive({
      width: globalThis.innerWidth,
      height: globalThis.innerHeight,
    });

    const onDimensionsChange = () => {
      windowDimensions.width = globalThis.innerWidth;
      windowDimensions.height = globalThis.innerHeight;
    };

    globalThis.addEventListener('resize', onDimensionsChange);
  }

  return windowDimensions;
};
